const en = {
  // Navigation and Home Page
  work_place: "Jobs & careers",
  company: " Your Future Takes Off Here",
  home_title: "Why Choose TIA?",
  Join: "Tirana International Airport",

  title1: "Dynamic environment with fast-paced and diverse roles in aviation",
  title2:
    "Growth opportunities through training, internal promotions, and professional development ",
  title3: "Inclusive culture with a collaborative and supportive atmosphere",
  title4:
    "Stability and impact in an institution of special national importance and global connections",

  reason1: "Fast-paced and diverse roles in aviation",
  reason2: "Training, internal promotions, and professional development",
  reason3: "A collaborative and supportive team atmosphere",
  reason4: "Work at a nationally vital and globally connected institution",

  All: "All",

  how_to_apply: "How to Apply",

  how_to_apply_steps: [
    "Check our Open Position as below",
    "Complete the application form with all required information",
    {
      bold: "Upload Your CV and Submit Your Application",
      normal: "(Only via link – No Physical Applications Accepted)",
    },
    "Submit your application before the specified deadline; late applications will not be considered",
    {
      bold: "Only shortlisted candidates will be contacted for further steps",
      normal:
        "(If not contacted, your CV remains in our database for future roles)",
    },
  ],

  home_subtitle:
    "At Tirana International Airport (TIA), we are always looking for talented professionals to join our team.",

  // Home Page Sections
  open_positions: "Current Opportunities",
  why_join_tia: "Why become part of TIA?",
  reason_dynamic_environment:
    "Become part of a dynamic and professional work environment.",
  reason_skills_development:
    "Develop your skills through continuous learning and training opportunities.",
  reason_contribute_growth:
    "Contribute to the growth and success of Albania's main airport.",
  sence_title: "Life Behind the Scenes at TIA",
  sence_text:
    "From runway to terminal, every role at TIA matters. Discover what it's like to be part of a team that makes air travel smooth, safe, and welcoming.",
  apply_now: "Apply Now",
  Department: "Department",
  Availability: "Employment Type",
  Location: "Location",

  // Job Details Page
  apply: "Apply",
  job_description_intro:
    "Tirana International Airport SHPK (TIA) is seeking to hire a {jobTitle} who will report to the {reportsToPositionFormat} of the company.",
  application_deadline: "Application deadline:",
  main_duties_responsibilities:
    "Main duties and responsibilities of the position:",
  position_requirements: "Position requirements:",
  education: "Education:",
  work_experience: "Work experience:",
  language_requirements: "Language requirements:",
  skills_competencies: "Skills and Competencies:",
  application_procedure: "Application Procedure",
  application_procedure_text:
    "Complete the application form with all required information. The Human Resources Department will contact only selected candidates after reviewing the documentation.",

  // Form Navigation
  back: "Back",
  continue: "Continue",
  submit_application: "Submit Application",

  // Form Steps
  step_personal: "Personal Information",
  step_education: "Education Background",
  step_experience: "Declaration",
  step_languages: "Languages",
  step_skills: "Skills",
  step_training: "Training",
  step_extra: "Additional Questions",
  step_cover_letter: "Cover Letter",
  step_declaration: "Declaration",

  // Personal Information Form
  full_name: "Full Name (as in ID/Passport)",
  gender: "Gender",
  female: "Female",
  male: "Male",
  date_of_birth: "Date of Birth",
  nationality: "Nationality",
  contact_number: "Contact Number",
  email_address: "Email Address",
  name_surname: "Name and Surname",

  // Education Form
  highest_education_level: "Highest Level of Education Completed",
  institution_name: "Institution Name",
  field_of_study: "Field of Study",
  graduation_year: "Graduation Year",
  additional_certifications: "Additional Certifications",
  certifications_placeholder:
    "Additional Certifications (e.g., Aviation Security, First Aid, IATA)",

  // Work Experience Form
  employer_name: "Employer Name",
  job_title: "Job Title",
  from: "From",
  to: "To",
  reason_for_leaving: "Reason for Leaving",
  main_responsibilities: "Main Responsibilities",
  position_not_specified: "Position not specified",
  employer_not_specified: "Employer Name not specified",

  // Language Skills
  language_proficiency: "Language Proficiency",
  language: "Language",
  level: "Level",
  select: "Select",
  add_language: "+ Add Language",
  delete: "Delete",

  // Language Levels
  basic: "Basic",
  intermediate: "Intermediate",
  fluent: "Fluent",
  native: "Native",

  // Computer Skills
  technical_other_skills: "Technical & Other Skills",
  computer_skills: "Computer Skills",
  enter_skill_name: "Other skills",
  ms_office: "MS Office Package (Word, Excel, PowerPoint, Outlook)",
  customer_service: "Customer Service",
  team_work: "Teamwork",
  communication_skills: "Communication Skills",
  problem_solving: "Problem Solving",
  leadership: "Leadership",
  airport_systems: "Airport Management Systems (e.g., Amadeus, SITA, Sabre)",

  // Training Form
  title: "Title",
  institution: "Institution",
  place_institution: "Enter education institution",
  location: "Location",
  street_city: "Street, city",
  year: "Year",
  duration: "Duration",

  // Extra Questions
  relatives_at_tia:
    "Do you have any relatives working for Tirana International Airport?",
  specify_relationship: "Specify relationship",
  how_learned_about_position: "How did you learn about the vacant position?",

  // Information Sources
  from_friend: "From a person who works at TIA",
  from_tia_employee: "From the website",
  from_newspaper: "From social media",
  from_internet: "Other",

  // Nationalities (en.js)
  shqiptar: "Albanian",
  italian: "Italian",
  grek: "Greek",
  turk: "Turkish",
  gjerman: "German",
  francez: "French",
  spanjoll: "Spanish",
  rus: "Russian",
  kinez: "Chinese",
  japonez: "Japanese",
  amerikan: "American",
  kanadez: "Canadian",
  brazilian: "Brazilian",
  arab: "Arab",
  indian: "Indian",
  korean: "Korean",
  suedez: "Swedish",
  norvegjez: "Norwegian",
  zelandz: "New Zealander",
  select_nationality: "Select nationality",

  //Education
  entry_level_education: "Completed 9-Year School",
  middle_level_education: "High School Diploma",
  vocational_education: "Vocational School",
  high_level_education: "Bachelor’s Degree (BSc/BA)",
  higher_education_master: "Master’s Degree (MSc/MA)",
  higher_education_professional: "Professional Master",
  higher_education_phd: "Doctorate (PhD)",
  select_education: "Select education",

  //language

  albanian_language: "Albanian",
  english_language: "English",
  italian_language: "Italian",
  german_language: "German",
  french_language: "French",
  spanish_language: "Spanish",
  turkish_language: "Turkish",
  greek_language: "Greek",
  russian_language: "Russian",
  chinese_language: "Chinese",
  japanese_language: "Japanese",
  arabic_language: "Arabic",
  portuguese_language: "Portuguese",
  serbian_language: "Serbian",
  croatian_language: "Croatian",
  bosnian_language: "Bosnian",
  macedonian_language: "Macedonian",
  romanian_language: "Romanian",
  bulgarian_language: "Bulgarian",
  polish_language: "Polish",
  no_positions_available: "No open positions",

  // Work Time Options
  full_time: "Full-Time",
  seasonal: "Seasonal",
  internship: "Internship",

  // Declaration
  declaration: "Declaration",
  declaration_text:
    "I hereby declare that the information provided is true and complete. I understand that any false statement may lead to disqualification or termination.",
  data_protection_agreement:
    "I agree to TIA's data protection and privacy policy.",
  verification_authorization:
    "I authorize verification of all information submitted.",
  full_name_declaration: "Full name",

  // Cover Letter
  cover_letter_placeholder: "Write cover letter",
  why_work_for_tia: "Why do you want to work for TIA?",

  // Summary Page
  summary: "Summary",
  date_of_birth_label: "Date of Birth:",
  address_residence: "Residential address:",
  gender_label: "Gender:",
  interest_for_work: "Interest for work",
  position_applied_for: "Position Applied For:",
  employment_type_desired: "Type of Employment Desired:",
  education_background: "Education Background",
  additional_certifications_label: "Additional Certifications:",
  work_experience_section: "Work Experience",
  responsibilities: "Responsibilities:",
  reason_for_leaving_label: "Reason for leaving:",
  computer_programs: "Computer Programs",
  languages_section: "Languages",
  additional_questions: "Additional questions",
  relatives_at_tia_question:
    "Do you have any relatives currently working at TIA?",
  specify_relatives: "Specify relatives:",
  how_learned_vacancy: "How did you learn about the vacancy?",

  // Common Options
  yes: "Yes",
  no: "No",

  // Validation Messages
  email_must_contain_at: "The email must contain the '@' symbol.",
  phone_minimum_digits: "Phone number must have at least 9 digits.",
  only_numbers_allowed: "Only numbers are allowed.",
  date_cannot_be_future: "Date cannot be in the future.",
  max_length_error: "Maximum length is {{count}} characters",

  // Error Messages
  error_fetching_jobs: "Error fetching jobs list:",
  error_fetching_form_model: "Error fetching form model:",

  // Placeholders
  enter_phone_number: "Enter phone number",
  yyyy_placeholder: "yyyy",
  date_placeholder: "dd/mm/yyyy",

  // Additional Personal Information
  address_of_residence: "Residential Address",
  position_details: "Position Details",
  position_applied_for_label: "Position Applied For",
  select_position: "Select Position",
  earliest_start_date: "Earliest start date available",
  salary_range_expectation: "Salary range expectation",
  attachments: "Attachments",
  upload_cv: "Upload CV",
  photo: "Photo",
  upload_cv_description: "Upload CV (PDF, max 2MB)",
  upload_photo: "Upload photo",
  motivation_letter: "Motivation Letter",
  upload_motivation_letter: "Upload Motivation Letter (Optional)",
  additional_information: "Additional Information",
  security_background_check:
    "Are you willing to undergo a security background check?",
  physical_fitness:
    "Are you physically fit for roles that require standing, lifting, or walking long hours?",
  relatives_at_tia_detailed:
    "Do you have any relatives currently working at TIA?",
  relative_name: "Name",
  name_placeholder: "name",
  relationship: "Relationship",
  relationship_placeholder: "Relationship",
  how_learned_vacancy_detailed: "How did you learn about the vacancy?",
  why_applying_position: "Reason for applying for this position at TIA",
  reason_for_applying: "Reason for applying",

  // Work Experience
  last_work_experience: "Last Work Experience",
  add_experience: "+ Add experience",
  edit: "Edit",

  // Training
  training_optional_note:
    "* This section is optional. You can fill it only if you wish.",
  training_title: "Training title",
  place_institution_detailed: "Enter education institution",
  street_city_detailed: "Street, city",
  add_training: "+ Add training",

  // Education Additional
  driving_license: "Driving License?",

  airport_systems_experience: "Airport Systems Experience",
  airport_systems_placeholder:
    "Airport Systems Experience (e.g., Amadeus, SITA)",

  // Header
  form: "Application",
  application: "Form",

  // Status and other labels
  status: "Status",
  selected: "Selected:",

  // File upload messages
  upload_image_or_pdf: "Please upload an image or PDF.",
  file_size_error: "File size should not exceed 2MB.",
  cv_pdf: "CV.pdf",
  image_png: "image.png",

  // Success/Error messages
  form_submitted_successfully: "Form submitted successfully!",
  submission_error: "Error submitting form.",
  please_fill_all_fields: "Please fill in all required fields.",

  // Education translations
  highest_education_completed: "Highest Level of Education Completed",
  driving_license_question: "Driving License?",

  // Training translations
  training_optional_text:
    "* This section is optional. You can fill it only if you wish.",
  training_title_label: "Training title",
  institution_label: "Institution",
  place_label: "Location",

  // ComputerProgram translations
  technical_skills: "Technical & Other Skills",
  computer_skills_label: "Computer Skills",

  // ExtraQuestion translations
  relatives_tia_question:
    "Do you have any relatives working for Tirana International Airport?",
  specify_relationship_label: "Specify relationship",
  how_learned_position: "How did you learn about the vacant position?",

  // Declaration translations
  declaration_title: "Declaration",

  // File upload messages
  upload_image_pdf_error: "Please upload an image or PDF.",
  file_too_large_error: "File size should be smaller than {size}MB.",

  // TextArea translations
  why_work_tia_default: "Why do you want to work for TIA?",

  // ApplicationForm translations
  application_sent_success: "Application sent successfully!",
  application_send_error: "Error sending application. Please try again.",

  // JobDetails additional
  position_requirements_detail: "Position requirements:",
  education_detail: "Education:",
  work_experience_detail: "Work experience:",
  language_requirements_detail: "Language requirements:",
  skills_competencies_detail: "Skills and Competencies:",
  application_procedure_detail: "Application Procedure",

  // Summary page additional
  type_employment_desired: "Type of Employment Desired:",
  additional_certifications_summary: "Additional Certifications:",
  responsibilities_summary: "Responsibilities:",
  reason_leaving_summary: "Reason for leaving:",
  relatives_working_question:
    "Do you have any relatives currently working at TIA?",
  specify_relatives_summary: "Specify relatives:",
  how_learned_vacancy_summary: "How did you learn about the vacancy?",

  // Success page additional
  applicationSuccess: "We have successfully received your application!",
  reviewPolicy:
    "*According to our internal Recruitment Policy, all applications will be reviewed based on the requirements of the position. Given the wide pool of candidates, applications will also be considered on a first come, first served basis.",
  onlySelected:
    "*Only selected candidates from the CV screening process will be contacted for an interview.",
  confidentiality:
    '*All applications will be treated with complete confidentiality according to law No. 9887 decided by the Albanian Parliament on "Personal Data Protection".',
  explorePositions: "Explore Open Positions",

  // FAQs questions

  questions1_FAQs: "Do I need experience in aviation to apply?",
  questions2_FAQs: "What are the working hours and shifts?",
  questions3_FAQs: "Can I apply for more than one position?",
  questions4_FAQs: "How will I be informed if I am selected?",

  //FAQs answers
  answers1_FAQs:
    "Not always. While some positions require prior experience or specific qualifications, many entry-level roles include training and development opportunities provided by TIA. Each job posting clearly states the requirements.",
  answers2_FAQs:
    "As an airport operates 24/7, many positions involve rotating shifts, including evenings, nights, weekends, and holidays. The exact schedule depends on the role and department.",
  answers3_FAQs:
    "Yes. You are welcome to apply for multiple positions, as long as you meet the requirements for each role.",
  answers4_FAQs:
    "Only candidates selected after the CV screening process will be contacted by the HR Team with details about the next steps in the recruitment process.",

  //FAQs
  faqs_title: "FAQs",

  //Testimonials
  testimonials_title: "Employee Testimonials",

  //Testimonials text
  testimonials_text1:
    "Working at TIA has given me the chance to grow professionally and feel part of something bigger.",
  testimonials_text2:
    "The team environment here is incredible. Every day brings new challenges and opportunities to learn.",
  testimonials_text3:
    "I love being part of a team that ensures safe and smooth travel for thousands of passengers daily.",
};

export default en;
